<template>
  <div
    class="page-form__footer"
    :class="{ 'page-form__footer--ml': mainMenuIsOpen }"
  >
    <div class="page-form__wrapper">
      <v-spacer />
      <v-btn
        :disabled="status === isLoading"
        :loading="status === isLoading"
        type="submit"
        color="accent"
        class="mx-0"
        depressed
        round
        @click="submit"
      >
        {{ $t(`${namespace}.importNfe`) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  props: {
    status: {
      type: Number
    }
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    }),
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.ImportNfePage'
    }
  },
  methods: {
    submit () {
      this.$emit('submit')
    }
  }
}
</script>
